import FieldConfig from "../../../proto/field-config"
import Task from "../../../../model2/task/task"
import FieldUsers from "../../../generic/users/users"
import FieldTaskUsers_TableCell from "./render/table/table-cell"
import FieldTaskUsers_ConditionForm from "./render/condition"
import {
    FieldMultiselect_filterValuesFiller
} from "../../../conditions/dropdown"
import Filter from "../../../../manager/filters/manager/filter"
import {
    FieldTaskUsers_filterGetOptions,
} from "../../../conditions/functions/get-filter-options"

export default class FieldTaskUsers extends FieldUsers {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-users'
        this.label      = 'All users'

        this.classes = _.assign({}, this.classes, {
            PopoverMenuScrollContainer  : 'h-200',
        })

        this.renderComponents.tableCell     = FieldTaskUsers_TableCell

        this.renderComponents.conditionForm = FieldTaskUsers_ConditionForm
        this.renderComponents.filterForm    = FieldTaskUsers_ConditionForm

        this.filterValuesFiller             = FieldMultiselect_filterValuesFiller
    }

    canEdit(model:Task):boolean {
        return model.acl.canAddUser
            || model.acl.canDeleteUser
    }

    filterGetAllOptions(): Option[] {
        return this.getOptions()
    }

    async filterGetOptions(filter: Filter): Promise<Option[]> {
        return await FieldTaskUsers_filterGetOptions(this, filter)
    }
}
